import * as React from 'react'
import { timestampToLongDate, formatCapitalized } from 'src/share/utils/utils'
import ReactHtmlParser from 'react-html-parser';
import { getContactInformation } from 'src/share/utils/formatContactInfo';

const ChildBanner = ({ id, child, isCurrent }): React.ReactElement => {
  function formatAge(age): string {
    return age === 1 ? `${age} year` : `${age} years`;
  }
  return (
    <div 
      className="child-banner__container" 
      aria-hidden={!isCurrent}
      tabIndex={-1}
      aria-labelledby={id}
    >
      <div className="child-banner__title">
        Missing
      </div>
      <div className="child-banner__body">
        {child.photo && <img src={child.photo} alt="Missing Child Image"/>}
        <div className="personal-information">
          <div>
            <h5>Name:</h5>
            <p>{formatCapitalized(child.name)}</p>
          </div>
          <div>
            <h5>Location:</h5>
            <p>{child.location}</p>
          </div>
          <div>
            <h5>Age:</h5>
            <p>{formatAge(child.age)}</p>
          </div>
          <div>
            <h5>Missing Date:</h5>
            <p>{timestampToLongDate(child.missingDate)}</p>
          </div>
          <div>
            <h5>Contact Information:</h5>
            <p>{ReactHtmlParser(getContactInformation(child.contactInformation))}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default React.memo(ChildBanner)



// WEBPACK FOOTER //
// ./src/modules/Dashboard/Global/components/ChildBanner.tsx